export enum SortByOption {
  AlphabeticalAtoZ = 'AlphabeticalAtoZ',
  AlphabeticalZtoA = 'AlphabeticalZtoA',
  ScoreHighToLow = 'ScoreHighest',
  ScoreLowToHigh = 'ScoreLowest',
  MostRecentAssigned = 'MostRecentAssigned',
  LeastRecentAssigned = 'LeastRecentAssigned',
  RecentlyCompleted = 'RecentlyCompleted',
  RecentlyUpdated = 'RecentlyUpdated',
  MostRecentlyCreated = 'MostRecentlyCreated',
  RecentlyActivated = 'RecentlyActivated',
}

export enum SortByOptionDescription {
  AlphabeticalAtoZ = 'A to Z',
  AlphabeticalZtoA = 'Z to A',
  ScoreHighToLow = 'Highest to lowest score',
  ScoreLowToHigh = 'Lowest to highest score',
  MostRecentAssigned = 'Most recently assigned',
  LeastRecentAssigned = 'Least recently assigned',
  RecentlyCompleted = 'Recently completed',
  RecentlyUpdated = 'Recently updated',
  MostRecentlyCreated = 'Most recently created',
  RecentlyActivated = 'Most recently activated',
}

/**
 * @deprecated To be replaced by SortByOption, do not use
 */
export enum SortByOptionDeprecated {
  NameAtoZ = 'NameAtoZ',
  NameZtoA = 'NameZtoA',
  MostRecent = 'MostRecent',
}

/**
 * @deprecated To be replaced by SortByOptionDescription, do not use
 */
export enum SortByOptionDescriptionDeprecated {
  NameAtoZ = 'A to Z',
  NameZtoA = 'Z to A',
  MostRecent = 'Most recent',
}

